import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({})).set('HelpVideo', new Immutable.Map(null))

/* Types */

export const ACTION_NEW_QUESTION_PROJECT = 'ACTION_NEW_QUESTION_PROJECT'

export const ACTION_SEARCH_QUESTION_PROJECT = 'ACTION_SEARCH_QUESTION_PROJECT'

export const ACTION_GET_QUESTION_PROJECT = 'ACTION_GET_QUESTION_PROJECT'

export const ACTION_GET_HELP_VIDEO_QUESTION = 'ACTION_GET_HELP_VIDEO_QUESTION'

export const ACTION_DELETE_QUESTION_PROJECT = 'ACTION_DELETE_QUESTION_PROJECT'

export const ACTION_UPDATE_QUESTION_PROJECT = 'ACTION_UPDATE_QUESTION_PROJECT'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW_QUESTION_PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_QUESTION_PROJECT:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_QUESTION_PROJECT:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_QUESTION_PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_QUESTION_PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_GET_HELP_VIDEO_QUESTION:
			return state.set('HelpVideo', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const addQuestionProject = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newQuestionProject',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_NEW_QUESTION_PROJECT, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchQuestionProject = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchParamQuestionProject',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getHelpVideoByQuestion = (id) => {

	return (dispatch) => {
		return new ClientHttpRequest({
			service: 'api/getHelpVideoByQuestion',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({ type: ACTION_GET_HELP_VIDEO_QUESTION, Obj: response.data})
		}).catch(error => {
			dispatch({ type: ACTION_GET_HELP_VIDEO_QUESTION, Obj: null})
			throw error
		})
	}
}

export const getQuestionProject = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getQuestionProject',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			if (response.data.pregunta.includes('|')) {
				let d = response.data.pregunta.split('|')
				response.data.pregunta = d[0]
				response.data.long = d[1]
			}
			dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getQuestionsProject = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/getQuestionsProject',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			response.data.forEach((item, i) => {
				item.pregunta = item.pregunta.slice(0, item.pregunta.length - 4);
				item.pregunta = item.pregunta.replace('|', '')
				if(!item.seccion)
					item.seccion = 'Preguntas generales'
			});
			dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteQuestionProject = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE_QUESTION_PROJECT, Obj: {code: '', message: ''} })
	}
}

export const updateQuestionProject = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/updateQuestionProject',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_QUESTION_PROJECT, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearQuestionProject = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} })
		dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Project/QuestionProject.js